<template>
  <div class="admin-login">
    <p>
      管理システムを利用するには<br>
      Googleアカウントによる<br>
      ログインが必要です
    </p>
    <b-button href="/oauth2/authorization/google" variant="danger">
      Googleでログイン
    </b-button>
    <p v-if="failed" class="failed-message">
      管理システムへのログインが許可された<br>
      Googleアカウントではありません
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      failed: this.$route.query.status == "failed"
    }
  }
}
</script>

<style scoped>
.admin-login {
  left: 50%;
  min-width: 500px;
  position: fixed;
  text-align: center;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}
.failed-message {
  color: #f00;
  font-size: 14px;
  margin-top: 10px;
}
</style>
